module.exports = __webpack_public_path__ + "static/media/one_device_is_all_you_need.a82c5b93.svg";